import { createQueryKeys } from '@lukemorales/query-key-factory';
import { QueryKeys } from '@/app/_shared/queries/query-keys';
import { fetchCategoryOverviewV3 } from '@/app/(pages)/(root)/api';

export const displayQueryKeys = createQueryKeys(QueryKeys.display, {
  getCategoryOverview: () => ({
    queryKey: ['categoryOverview'],
    queryFn: () => fetchCategoryOverviewV3(),
  }),
});
